/**
 * store search condition of issue history
 */
const state = {
  historyIssueList: null,
  historyIssueListPrint: null,
  listErrorUps: null
};

const getters = {
  historyIssueList: state => state.historyIssueList,
  historyIssueListPrint: state => state.historyIssueListPrint,
  listErrorUps: state => state.listErrorUps
};

const mutations = {
  saveHistoryIssueList(state, editIssueData) {
    if (!editIssueData) {
      return;
    }
    if (editIssueData.historyIssueList) {
      state.historyIssueList = editIssueData.historyIssueList;
    }
    state.historyIssueListPrint = editIssueData.historyIssueListPrint;

    state.listErrorUps = null;
  },
  saveListErrorUps(state, listErrorUps) {
    state.listErrorUps = listErrorUps;
  },
  clearHistoryIssueList(state, deleteHistoryIssueList) {
    if (deleteHistoryIssueList) {
      state.historyIssueList = null;
    }
    state.historyIssueListPrint = null;
    state.listErrorUps = null;
  }
};

export default {
  state,
  getters,
  mutations
};
